import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { ShareErrorState } from "@src/features/publicShareLinks/components/ShareErrorState";
import { ShareRouteErrorBoundary } from "@src/features/publicShareLinks/components/ShareRouteErrorBoundary";
import { ShareRoute } from "@src/features/publicShareLinks/Share.route";

const desktopRouter = createBrowserRouter([
  {
    path: "/share/:experienceId",
    element: <ShareRoute />,
    errorElement: <ShareRouteErrorBoundary />,
  },
  {
    path: "*",
    element: <ShareErrorState errorType="not-found" />,
  },
]);

export const ShareApp = () => {
  return (
    <ErrorBoundary fallback={<ShareErrorState errorType="network-error" />}>
      <RouterProvider router={desktopRouter} />
    </ErrorBoundary>
  );
};
